import { createFileRoute } from '@tanstack/react-router';
import { HelpCenterPage } from '@/features/help-center/HelpCenterPage';

export type HelpCenterTab = 'faq' | 'release-notes';

export const Route = createFileRoute('/_app/help-center')({
  validateSearch: (search: Record<string, unknown>): { tab: HelpCenterTab } => ({
    tab: search.tab === 'release-notes' ? 'release-notes' : 'faq',
  }),
  component: HelpCenterPage,
});
